import type { IndicatorComparisonPayload } from '@Application/Indicators/Actions/indicatorPeriodPayload';

export type DirectionKind = 'up' | 'down' | 'stable' | 'new' | 'none';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class IndicatorComparisonView {
	readonly current: number;
	readonly previous: number;

	constructor(payload: IndicatorComparisonPayload) {
		this.current = payload.current;
		this.previous = payload.previous;

		Object.freeze(this);
	}

	get direction(): DirectionKind {
		if (this.previous === 0) {
			return this.current === 0 ? 'none' : 'new';
		}
		if (this.current > this.previous) {
			return 'up';
		}
		if (this.current < this.previous) {
			return 'down';
		}

		return 'stable';
	}

	get difference(): number {
		return this.current - this.previous;
	}

	/** Relative change rounded to the unit; `null` when there is no previous base to compare to. */
	get percent(): number | null {
		if (this.previous === 0) {
			return null;
		}

		return Math.round((this.difference / this.previous) * 100);
	}
}

export default IndicatorComparisonView;
